import { isCMHK } from '@fs/utils'
import { getLogoutInstance, invokeToast } from '../http.tool'
import { t } from '../i18n/t.js'
import MYLINK_JSBRIDGE from '@fs/jsbridge/dist/lib/mylinkJsBridge'
import { clearUserInfo } from '@repo/common-utils/utils/utils'

export default () => (response) => {
  if (isCMHK()) {
    // 中移动
    switch (response.data?.error?.code) {
      case 100034:
        // 互踢弹窗
        getLogoutInstance().open()
        return Promise.reject(response)
      case 100008:
      case 100033:
        invokeToast({
          forbidClick: true,
          message: t('requestCode.dlsxqcxdl'),
          onClose: () => {
            // session失效关闭webview
            MYLINK_JSBRIDGE.backToHomePage()
            clearUserInfo()
          },
        })
        return Promise.reject(response)
      default:
        break
    }
  }
  return response
}
